import React from 'react'
import RootCardSection from './RootCardSection'
import GoalCardSection from './GoalCardSection'
import "../styles/CardSection.css"
import {useState} from 'react'

const CardSection = ({actorPair, connectedMovies, connectedActors, handleRemoveLastActor, completeConnection}) => {
    const [hoverConnections, setHoverConnections] = useState([]);
    const handleHoverConnections = (hoverConnectedMovies) => {
        setHoverConnections(hoverConnectedMovies);
    }

  return (
    <>
        <div className="connected-movies-wrapper">
            <div className="connected-movies-container">
                {connectedMovies.length > 0 ? 
                (
                    <>
                    <h4>{hoverConnections.slice(0,3).join(', ')}</h4>
                    </>
                )
                :
                (
                    <p>Connect these actors via their co-stars using at most 5 more actors!</p>
                )
                }
            </div>
        </div>
        {actorPair ? (
            <>
                <div className="card-section-container">
                    <RootCardSection actorPair={actorPair} connectedMovies={connectedMovies} connectedActors={connectedActors} handleRemoveLastActor={handleRemoveLastActor}
                    completeConnection={completeConnection} onHoverChange={handleHoverConnections}/>
                    <h1 className="link-icon">?</h1>
                    <GoalCardSection actorPair={actorPair} connectedMovies={connectedMovies} completeConnection={completeConnection}/>
                </div>
            </>
                
        )
        :
        (
            <div className="card-section-container">
                <p>Fetching Actors...</p>
            </div>
        )
        }
        
    </>
  )
}

export default CardSection